/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY
// See angular/tools/gulp-tasks/cldr/extract.js

export default [
  [
    ['මැ', 'ම', 'පා', 'උ', 'ද', 'හ', 'රෑ', 'මැ'],
    [
      'මැදියම', 'මධ්\u200dයාහ්නය', 'පාන්දර', 'උදේ',
      'දවල්', 'හවස', 'රෑ', 'මැදියමට පසු'
    ],
  ],
  [
    [
      'මැදියම', 'මධ්\u200dයාහ්නය', 'පාන්දර', 'උදේ',
      'දවල්', 'හවස', 'රෑ', 'මැදියමට පසු'
    ],
    ,
  ],
  [
    '00:00', '12:00', ['01:00', '06:00'], ['06:00', '12:00'], ['12:00', '14:00'],
    ['14:00', '18:00'], ['18:00', '24:00'], ['00:00', '01:00']
  ]
];
